import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Box, Stack, Typography } from '@mui/material'
import FileInput from '../../../../components/fileInput/FileInput'
import { MAINTENIR_ENFANT_MAJEUR_FIELDS } from '../services/maintenirEnfantMajeurConstants'
import RadioInput from '../../../../components/form/RadioInput'
import ButtonLink from '../../../../components/ButtonLink'
import NissTextInput from '../../../../components/NissTextInput'
import { toUpperCase } from '../../../../utils/stringUtils'

type StudyingFormProps = {
	selectedChild?: any
	values: any
	touched: any
	errors: any
}

const FIRST_REGIME_DATA = [
	{
		value: '1',
		label: 'Oui'
	},
	{
		value: '0',
		label: 'Non'
	}
]

const InternshipForm: React.FC<StudyingFormProps> = ({ selectedChild, values, touched, errors }) => {
	const intl = useIntl()
	const [modifyNISS, setModifyNISS] = useState<boolean>(false)

	return (
		<Stack direction="column" spacing="24px">
			<Typography variant="body2">
				<FormattedMessage id="maintenirEnfantMajeur.input.internship.description" />
			</Typography>
			<FileInput
				maxFileNumber={1}
				name={MAINTENIR_ENFANT_MAJEUR_FIELDS.CERTIFICAT}
				title={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.internship.file' })}
			/>
			<RadioInput
				name={MAINTENIR_ENFANT_MAJEUR_FIELDS.FIRST_REGIME}
				label={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.internship.affiliation' })}
				data={FIRST_REGIME_DATA}
				error={touched && touched[MAINTENIR_ENFANT_MAJEUR_FIELDS.FIRST_REGIME] && errors && errors[MAINTENIR_ENFANT_MAJEUR_FIELDS.FIRST_REGIME]}
			/>

			{values[MAINTENIR_ENFANT_MAJEUR_FIELDS.FIRST_REGIME] === '1' ? (
					<>
						<Typography variant="body2">
							<FormattedMessage id="maintenirEnfantMajeur.input.ssData.description" />
						</Typography>
						<NissTextInput
							name={MAINTENIR_ENFANT_MAJEUR_FIELDS.INTERNSHIP_NISS_1}
							label={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.niss' })}
							helperText={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.nissHelper' })}
							format={toUpperCase}
							maxWidth="unset"
							mandatory
						/>
						<FileInput
							maxFileNumber={1}
							name={MAINTENIR_ENFANT_MAJEUR_FIELDS.INTERNSHIP_ATTESTATION_SS_1}
							title={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.file.title' })}
							label={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.file.label' })}
						/>
					</>
				)
				: values[MAINTENIR_ENFANT_MAJEUR_FIELDS.FIRST_REGIME] === '0' ? (
					<>
						<Typography variant="body2">
							<FormattedMessage id="maintenirEnfantMajeur.input.ssData.description" />
						</Typography>
						<NissTextInput
							name={MAINTENIR_ENFANT_MAJEUR_FIELDS.INTERNSHIP_NISS_2}
							label={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.niss' })}
							helperText={modifyNISS ? intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.nissHelper' }) : undefined}
							defaultValue={selectedChild?.matorg}
							disabled={!modifyNISS}
							format={toUpperCase}
							maxWidth="unset"
							mandatory
						/>
						{modifyNISS ? (
							<FileInput
								maxFileNumber={1}
								name={MAINTENIR_ENFANT_MAJEUR_FIELDS.INTERNSHIP_ATTESTATION_SS_2}
								title={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.file.title' })}
								label={intl.formatMessage({ id: 'maintenirEnfantMajeur.input.ssData.file.label' })}
							/>
						) : (
							<>
								<Typography variant="body2">
									<FormattedMessage id="maintenirEnfantMajeur.input.ssData.modify" />
								</Typography>
								<Box display="flex" justifyContent="center">
									<ButtonLink sx={{ width: '230px' }} onClick={() => setModifyNISS(true)}>
										<FormattedMessage id="global.button.modify" />
									</ButtonLink>
								</Box>
							</>
						)}
					</>
				) : <></>
			}
		</Stack>
	)
}

export default InternshipForm
